module.exports = __webpack_public_path__ + "assets/img/3177e1e7038ea6c09d0644049e4df889.png";